import React from 'react';

import styles from './Divider.module.scss';


const Divider = ({ variant, ...theRestOfTheProps }) => {
  const prohibitedProps = [
    'class',
    'className',
  ];

  prohibitedProps.forEach((key) => {
    if (key in theRestOfTheProps) {
      throw new Error(`Prop "${key}" is prohibited in Divider`);
    }
  });

  let dividerVariant = null;

  switch (variant) {
    case "primary":
      dividerVariant = styles.primary;
      break;

    case "secondary":
      dividerVariant = styles.secondary;
      break;

    default:
      dividerVariant = styles.primary;
  }

  return (
    <hr className={dividerVariant} />
  );
};

export default Divider;
